import { availableCommands$ } from 'aiControlledCommands/viewpoint/availableCommands$';
import { availableCommands$ as futureStateAvailableCommands$ } from 'aiControlledCommands/futureState/availableCommands$';
import { availableCommands$ as productTourAvailableCommands$ } from 'aiControlledCommands/productTours/availableCommands$';
import { availableCommands$ as traversalBuildingAvailableCommands$ } from 'aiControlledCommands/traversalBuilding/availableCommands$';
import type { AiControlledCommand } from 'aiControlledCommands/types';
import { selectedModule$ } from 'appContainer/selectedModule$';
import { AppModules, type PayloadShowAppModule } from 'appContainer/types';
import { featureOperations, Features } from '@ardoq/features';
import { featureContext$ } from 'streams/featureContext$';
import { availableCommands$ as integrationsAvailableCommands$ } from 'aiControlledCommands/integrations/automapColumns/availableCommands$';
import {
  combineLatest,
  distinctUntilChanged,
  map,
  of,
  switchMap,
  type Observable,
} from 'rxjs';

const defaultTools: AiControlledCommand[] = [];

const isAiChatAvailable$ = featureContext$.pipe(
  map(featureContext =>
    featureOperations.hasFeature(featureContext, Features.AI_CHAT)
  ),
  distinctUntilChanged()
);

const selectModuleCommands$ = ({
  selectedModule,
}: PayloadShowAppModule): Observable<AiControlledCommand[]> => {
  switch (selectedModule) {
    case AppModules.WORKSPACES:
      return availableCommands$;
    case AppModules.TRANSFORMATIONS:
      return futureStateAvailableCommands$;
    case AppModules.INTEGRATIONS:
      return integrationsAvailableCommands$;
    default:
      return of(defaultTools);
  }
};

const moduleCommands$ = selectedModule$.pipe(switchMap(selectModuleCommands$));

const chatAssistantTools$ = combineLatest([
  moduleCommands$,
  traversalBuildingAvailableCommands$,
]).pipe(map(commands => commands.flat()));

export const availableChatAssistantTools$ = isAiChatAvailable$.pipe(
  switchMap(isAiChatAvailable =>
    isAiChatAvailable ? chatAssistantTools$ : of(defaultTools)
  )
);

export const productTourCommands$ = isAiChatAvailable$.pipe(
  switchMap(isAiChatAvailable =>
    isAiChatAvailable ? productTourAvailableCommands$ : of(defaultTools)
  )
);
